import { Box, Card, Grid, Typography, styled } from "@material-ui/core";
import * as React from "react";

import bg from "../../images/features_background.jpg";

const Background = styled(Box)(({ theme }) => ({
  backgroundImage: `url(${bg})`,
  backgroundPosition: "center",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  marginTop: theme.spacing(8),
  padding: theme.spacing(4),
}));

export const Features = () => {
  return (
    <Background>
      <Box maxWidth={1140} marginLeft="auto" marginRight="auto">
        <Grid container={true} spacing={4}>
          <Grid item={true} xs={6} md={3}>
            <Card>
              <Box my={2} mx={1} textAlign="center">
                <Typography variant="h1">15+</Typography>
                <Typography variant="body1" color="textSecondary" noWrap={true}>
                  <b>Years of Industry Experience</b>
                </Typography>
              </Box>
            </Card>
          </Grid>
          <Grid item={true} xs={6} md={3}>
            <Card>
              <Box my={2} mx={1} textAlign="center">
                <Typography variant="h1">290</Typography>
                <Typography variant="body1" color="textSecondary" noWrap={true}>
                  <b>Pages</b>
                </Typography>
              </Box>
            </Card>
          </Grid>
          <Grid item={true} xs={6} md={3}>
            <Card>
              <Box my={2} mx={1} textAlign="center">
                <Typography variant="h1">8+</Typography>
                <Typography variant="body1" color="textSecondary" noWrap={true}>
                  <b>Hours Of Thrilling Reading</b>
                </Typography>
              </Box>
            </Card>
          </Grid>
          <Grid item={true} xs={6} md={3}>
            <Card>
              <Box my={2} mx={1} textAlign="center">
                <Typography variant="h1">10</Typography>
                <Typography variant="body1" color="textSecondary" noWrap={true}>
                  <b>Unique Characters</b>
                </Typography>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Background>
  );
};



// WEBPACK FOOTER //
// ./src/components/Features/Features.tsx